/* eslint-disable @angular-eslint/component-selector */
import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { IonMenu, MenuController, NavController } from '@ionic/angular';
import { from } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EmployeesService } from 'src/app/services/employees.service';

@Component({
    selector: 'menu-employees',
    templateUrl: './menu-employees.component.html',
    styleUrls: ['./menu-employees.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MenuEmployeesComponent implements OnInit {

    // Definir un ViewChild para el menú lateral.
    @ViewChild(IonMenu) menu: IonMenu;
    @Input() menuId: string = 'employee-menu';

    constructor(
        private authService: AuthenticationService,
        private router: Router,
        private navCtrl: NavController,
        private menuCtrl: MenuController,
        public employeesService: EmployeesService,
    ) {
    }

    ngOnInit() {
        this.configureMenu();
    }

    ionViewDidEnter() {
        // Cerrar el menú lateral cuando se navega a otra página.
        this.router.events.subscribe(event => {
            try {
                if (event instanceof NavigationStart) {
                    this.menu.close();
                }
            }
            catch (error) {
                console.log(error);
            }
        });

        // Cargar los mensajes no leídos.
        this.employeesService.getMensajes();
    }

    // #region Métodos del componente

    async closeMenu() {
        if (this.menu.isOpen()) {
            await this.menuCtrl.close(this.menuId); // Método para cerrar el menú

            // Mover el foco fuera del menú
            //this.mainContent.nativeElement.focus();
        }
    }

    async navigateTo(path: string) {
        console.log('Acceso a la ruta:', path);

        // Cerrar el menú
        await this.menuCtrl.close(this.menuId);

        // Ir a la página, poniéndola como la ruta actual
        this.router.navigate([path], { replaceUrl: true });
    }

    /**
     * Cierra la sesión del usuario y navega a la página de inicio.
     */
    public logout(): void {
        from(this.authService.logout()).subscribe({
            next: (resultado) => {
                this.navCtrl.navigateRoot('/login');
            }
        });
    }

    // #endregion

    // #region Métodos privados

    private async configureMenu() {
        try {
            const menu = await this.menuCtrl.get(this.menuId);
            if (menu) {
                console.log('Configurando el menú');
                this.menu.swipeGesture = false;
            } else {
                console.error('El menú no está disponible');
            }
        } catch (error) {
            console.error('Error al configurar el menú:', error);
        }
    }

    // #endregion
}
